// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SearchNewPinButton: 'search-new-pin-button',
	SyncDetailsButton: 'sync-details-button',
	SimilarNamesButton: 'similar-names-button',
	ViewAdjacentLotButton: 'view-adjacent-lot-button',
	PurchaseMapButton: 'purchase-map-button',
	PurchaseParcelButton: 'purchase-parcel-button',
	PurchaseDeletedCheckbox: 'purchase-deleted-checkbox',
	StarIcon: 'star-icon',
	PartParcelIcon: 'part-parcel-icon',
	PartiesIcon: 'parties-icon',
	PartParcelIcon1: 'part-parcel-icon-1',
	PartiesIcon1: 'parties-icon-1',
	PartiesIcon2: 'parties-icon-2',
	PdfIcon: 'pdf-icon',
	SelectPinDiv: 'select-pin-div',
	SelectPinDiv1: 'select-pin-div-1',
	OpenPdfDiv: 'open-pdf-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
